import { observable } from "mobx";
import { copy, copyArray } from "../utils/data";
import { LookupType, EmptyId } from "./enums";

export class LookupValue {
  @observable idHash: string;
  @observable type: LookupType;
  @observable order:number;
  @observable parent?:number;
  @observable value: string;
  @observable regionId?: string;

  constructor(lv?: LookupValue) {
    this.idHash = EmptyId;
    this.type = LookupType.Unknown;
    this.order = 0;
    this.parent = null;
    this.value = "";
    this.regionId = null;
    if (lv) {
        copy(lv, this);
    }
  }
}

export class RegionReferralSource {
  @observable name: string;
  @observable idHash: string;
  constructor(rrs?: RegionReferralSource) {
    this.name = this.idHash = "";
    if (rrs) {
      copy(rrs, this);
    }
  }
}

export class RegistrationRegion {
  @observable sources: Array<RegionReferralSource>;
  @observable name: string;
  @observable idHash: string;

  constructor(rr?: RegistrationRegion) {
    this.sources = new Array<RegionReferralSource>();
    this.name = this.idHash = "";
    if (rr) {
      copy(rr, this, ["sources"]);
      copyArray(rr.sources, this.sources, (rrs: RegionReferralSource) => { return new RegionReferralSource(rrs); });
    }
  }
}


export interface IInMemLookup {
  key: string;
  value: string;
}



// WEBPACK FOOTER //
// ./src/models/lookup.ts